import { useEffect } from "react";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Divider,
  IconButton,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField, FormControl, InputLabel, MenuItem, Select
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit, Delete, ArrowBack, Agriculture, Rocket } from "@mui/icons-material";
import apiService from "../../service/apiService";
import { MoveToInbox } from "@mui/icons-material"; 
import { CheckCircle } from "@mui/icons-material";
import { format, parseISO } from "date-fns";

const Plans = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cropPlans: initialCropPlans, selectedRow } = location.state || {};
  const [cropPlans, setCropPlans] = useState(initialCropPlans || []);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = useState(null);
  const [updatedArea, setUpdatedArea] = useState("");
  const [actualarea, setActualArea] = useState("");
  const [updatedSeedName, setUpdatedSeedName] = useState("");
  const [updatedClassName, setUpdatedClassName] = useState("");
  const [updatedVarietyName, setUpdatedVarietyName] = useState("");
  const [updatedCropType, setUpdatedCropType] = useState("");
  const [seeds, setSeeds] = useState([]);
  const [seedVarieties, setSeedVarieties] = useState([]);
  const [cropTypes, setCropTypes] = useState([]);
  const [seedClasses, setSeedClasses] = useState([]);
  const [childdata, setChildData] = useState([]);
  const jsonData = JSON.stringify(cropPlans);
  const [plannedarea, setPlannedarea] = useState(0);
  const [leaseArea, setLeaseArea] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [cropplanmasterid, setCropPlanMasterId] = useState(0);
  const [verifiedBy, setVerifiedBy] = useState([]);
  // console.log(jsonData);


  const handleSubmit = () => {
    // Find seedClassId based on className
    const selectedClass = seedClasses.find(
      (seedClass) => seedClass.className === formData.className

    );

    const newEntry = {
      seedSowingDate: formData.seedSowingDate,
      cultivatedArea: parseFloat(formData.cultivatedArea),
      // cropCuttingDate: formData.cropCuttingDate || "",
      // yield5x5: parseFloat(formData.yield5x5),
      cropPlanId: formData.cropPlanId,
      seedClassId: Number(formData.seedClassId)
    };

    const existingData = JSON.parse(localStorage.getItem("cropData")) || [];
    const updatedData = [...existingData, newEntry];

    localStorage.setItem("cropData", JSON.stringify(updatedData));

    console.log("Data saved successfully:", newEntry);

    setFormData({
      seedSowingDate: "",
      cultivatedArea: "",
      yield5x5: "",
      cropPlanId: "",
      seedClassId: 0,
    });
    setOpenDialog(false);
  };



  const handleVerify = async () => {
    console.log("Verify button clicked");

    const cropPlanMasterId = cropplanmasterid;
    if (!cropPlanMasterId) {
      console.error("Crop Plan Master ID is not available");
      alert("Crop Plan Master ID is not available.");

      return;
    }
    try {
      const response = await apiService.put('/crop-plan-master/verify', {
        cropPlanMasterIds: [cropplanmasterid],
        remarks: "Verified successfully"
      });

      console.log("Verification successful:", response.data);
      alert("Verification successful!");

    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Status code:", error.response.status);
        alert(`Verification failed: ${error.response.data.message || "An error occurred"}`);

      } else {
        console.error("Error occurred:", error.message);
        alert(`Verification failed: ${error.message}`);

      }
    }
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    seedSowingDate: "",
    cultivatedArea: "",
    yield5x5: "",
    cropPlanId: "",
    seedClassId: 0,
  });

  const handleCultivationClick = (row) => {
    // console.log("plan area is line 129 ", row);
    const seedClass = seedClasses.find(sc => sc.className === row.className);
    setPlannedarea(row.area + row.leasearea);
    setFormData({
      cropPlanId: row.id,
      seedClassId : seedClass ? seedClass.seedClassId : 0,
      seedSowingDate: "",
      cultivatedArea: "",
      // yield5x5: "",
    });
    setOpenDialog(true);
  };


  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    const correspondingPlan = childdata.find(
      (plan) => plan.cropPlanId === formData.cropPlanId
    );

   

    if (/^[0-9]*[.,]?[0-9]*$/.test(value)) {
      setFormData({ ...formData, cultivatedArea: value });
    }

    // Update the formData state
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

 



  const handleDeleteClick = (row) => {
    setSelectedRowForEdit(row);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedRowForEdit(null);
  };


  const handleAddProduction = async () => {
    const isConfirmed = window.confirm("Are you sure you want to move production?");

    if (!isConfirmed) {
      return;
    }

    if (!farmerDetails?.id) {
      console.error("Farmer details not available.");
      return;
    }

    const cropPlanMasterId = farmerDetails.id;

    const cropProductions = JSON.parse(localStorage.getItem("cropData")) || [];

    if (cropProductions.length === 0) {
      console.error("No crop production data available to send.");
      alert("No crop production data available to move.");
      return;
    }

    // Prepare the request body
    const requestBody = {
      cropPlanMasterId,
      cropProductions,
    };

    try {
      // Make the API call using axios
      const response = await apiService.post("/crop-master/create-production", requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Handle the response
      console.log("Production moved successfully:", response.data);

      // Prompt before clearing local storage
      const clearDataConfirmed = window.confirm(
        "Production data moved successfully!"
      );
      fetchAllData();

      if (clearDataConfirmed) {
        localStorage.removeItem("cropData");
      } else {
      }
    } catch (error) {
      console.error("Error while moving production:", error.response?.data || error.message);
      alert("Failed to move production. Please try again.");
    }
  };


  const fetchSeeds = async () => {
    try {
      const response = await apiService.get("/seeds/get-all");
      setSeeds(response.data);
    } catch (error) {
      console.error("Error fetching seeds:", error);
    }
  };
  const fetchSeedClasses = async () => {
    try {
      const response = await apiService.get("/seed-classes/get-all");
      setSeedClasses(response.data);
    } catch (error) {
      console.error("Error fetching seed classes:", error);
    }
  };

  const fetchSeedVarieties = async () => {
    try {
      const response = await apiService.get("/seed-varieties/get-all");
      setSeedVarieties(response.data);
    } catch (error) {
      console.error("Error fetching seed varieties:", error);
    }
  };

  const fetchCropTypes = async () => {
    try {
      const response = await apiService.get("/croptypes/get-all-croptypes");
      setCropTypes(response.data);  // Store crop types in the state
    } catch (error) {
      console.error("Error fetching crop types:", error);
    }
  };

  const fetchAllData = async () => {
    if (!farmerDetails?.id) {
      console.error("Farmer details not available.");
      return;
    }
    const cropPlanMasterId = farmerDetails.id;

    try {

      const response = await apiService.get("/crop-plan-master/get-cropplan-details/" + cropPlanMasterId);
      console.log("child plan data is", response.data.body.cropPlans);
      setChildData(response.data.body.cropPlans);
      setIsVerified(response.data.body.isVerified );
      setCropPlanMasterId(response.data.body.cropPlanMasterId);
      setVerifiedBy(response.data.body.verificationLogs[0] || []);
    } catch (error) {
      console.error("Error fetching seed classes:", error);
    }
  };

  useEffect(() => {


    fetchSeeds();
    fetchSeedClasses();
    fetchSeedVarieties();
    fetchCropTypes();
    fetchAllData();

  }, []);

  // Confirm deletion
  const handleDeleteConfirm = async () => {
    const { id: cropPlanId } = selectedRowForEdit;
    try {
      const response = await apiService.delete(`/crop-plans/delete/${cropPlanId}`);
      if (response.data.statusValue) {
        setCropPlans((prevPlans) =>
          prevPlans.filter((plan) => plan.cropPlanId !== cropPlanId)
        );
        console.log(response.data.message);
      } else {
        console.error("Failed to delete crop plan.");
      }
    } catch (error) {
      console.error(`Error deleting crop plan: ${cropPlanId}`, error);
    } finally {
      handleCloseDeleteDialog();
      fetchAllData();
    }
  };
  // Open edit dialog
  const handleEditClick = (row) => {
    console.log("first data are ", row);

    const matchedCrop = cropTypes.find(ct => ct.cropType === row.cropType);
    const cropTypeId = matchedCrop ? matchedCrop.cropTypeId : "";

    const matchedSeed = seeds.find(s => s.seedName === row.seedName);
    const seedId = matchedSeed ? matchedSeed.seedId : "";

    const matchedClass = seedClasses.find(sc => sc.className === row.className);
    const classId = matchedClass ? matchedClass.seedClassId : "";

    const matchedVariety = seedVarieties.find(sv => sv.varietyName === row.varietyName);
    const varietyId = matchedVariety ? matchedVariety.seedVarietyId : "";

    setSelectedRowForEdit(row);
    setUpdatedArea(row.area);
    setActualArea(row.area);
    setLeaseArea(row.leasearea);
    setUpdatedCropType(cropTypeId);
    setUpdatedSeedName(seedId);
    setUpdatedClassName(classId);
    setUpdatedVarietyName(varietyId);
    setOpenEditDialog(true);
  };

  // Close edit dialog
  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSelectedRowForEdit(null);
  };



  // Confirm area update
  const handleEditConfirm = async () => {
    const isConfirmed = window.confirm("Are you sure you want to edit this crop plan?");
    if (!isConfirmed || !selectedRowForEdit) return;

    const { id: cropPlanId } = selectedRowForEdit;
    const areaAsDouble = parseFloat(updatedArea);

    if (isNaN(areaAsDouble) || areaAsDouble <= 0) {
        console.error("Invalid area value. Please enter a valid number.");
        return;
    }

    try {
        const payload = {
            area: areaAsDouble,
            leaseArea: Number(leaseArea),
            seedId: updatedSeedName ? Number(updatedSeedName) : null, // Avoid converting "" to 0
            seedClassId: updatedClassName ? Number(updatedClassName) : null, // Avoid converting "" to 0
            seedVarietyId: updatedVarietyName ? Number(updatedVarietyName) : null, // Avoid converting "" to 0
            cropTypeId: updatedCropType ? Number(updatedCropType) : null, // Avoid converting "" to 0
        };

        console.log("Final Payload:", payload);

        const response = await apiService.put(`/crop-plans/update/${cropPlanId}`, payload);

        if (response.data.status === true) {
            fetchAllData();
            fetchFarmerDetailsById();
            console.log(response.data.message);
        } else {
            console.error("Failed to update crop plan.");
        }
    } catch (error) {
        console.error(`Error updating crop plan: ${cropPlanId}`, error);
    } finally {
        handleCloseEditDialog();
    }
  };



  const handleBack = () => {
    navigate(-1);
  };
  const farmerDetails = selectedRow || {};
  const [availablearea, setAvailableArea] = useState(0);
  const fetchFarmerDetailsById = async () => {
    try {
        const response = await apiService.get(`/farmers/get-farmer-details/${parseInt(farmerDetails.farmerId)}`);
        setAvailableArea(response.data.body.availableLand); 
    } catch (error) {
        console.error("Error fetching farmers:", error);
    }
  };

  useEffect(() => {
    if ( parseInt(farmerDetails.farmerId) > 0) {
        fetchFarmerDetailsById();
    }
}, [parseInt(farmerDetails.farmerId)]);

const totalAvailableArea = parseFloat(availablearea) + parseFloat(actualarea || 0);

const handleAreaChange = (e) => {
  const value = e.target.value;
  if (/^\d*\.?\d*$/.test(value)) {
    const numericValue = parseFloat(value || 0);
    if (numericValue <= totalAvailableArea) {
      setUpdatedArea(value);
    } else {
      alert(`Cannot exceed total available land (${totalAvailableArea} ha).`);
    }
  }
};
  return (

    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBack}
          sx={{
            marginBottom: 2,
            backgroundColor: "#1976d2",
            color: "white",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          Back
        </Button>
        <Box sx={{ display: "flex", gap: 2 }}>

          <Button
            onClick={handleAddProduction}
            startIcon={<MoveToInbox />}
            sx={{
              marginBottom: 2,
              backgroundColor: "#28a745",
              color: "white",
              "&:hover": {
                backgroundColor: "#218838",
              },
            }}
          >
            Move Production
          </Button>
          {/* {isVerified ? (
          <Typography
            sx={{
              marginBottom: 2,
              fontSize: "16px",
              fontWeight: "bold",
              color: "#00796b",
            }}
          >
            ✅ Verified
          </Typography>
        ) : (
          <Button
            onClick={handleVerify}
            startIcon={<CheckCircle />}
            sx={{
              marginBottom: 2,
              backgroundColor: "#00796b",
              color: "white",
              "&:hover": { backgroundColor: "#004d40" },
            }}
          >
            Verify
          </Button>
          )} */}
        </Box>
      </Box>



      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
          Crop Plan Details:
        </Typography>
<div className="d-flex">
  <div className="col-6">
      <Box sx={{ marginBottom: 2 }}>
        <Typography variant="body1"><strong>Farmer Name:</strong> {farmerDetails.farmer}</Typography>
        <Typography variant="body1"><strong>Caste:</strong> {farmerDetails.caste || "Not Available"}</Typography>
        <Typography variant="body1"><strong>Gender:</strong> {farmerDetails.gender || "Not Available"}</Typography>
        <Typography variant="body1"><strong>Season:</strong> {farmerDetails.season || "Not Available"}</Typography>
        <Typography variant="body1"><strong>PG Code:</strong> {farmerDetails.pgCode || "Not Available"}</Typography>
        <Typography variant="body1"><strong>farmer Id:</strong> {farmerDetails.farmerId || "Not Available"}</Typography>
      </Box>
    </div>
    <div className="col-6">
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
          Verification Details:
        </Typography>
      {verifiedBy?.verifierName && verifiedBy?.role ? (
        <Box sx={{ marginBottom: 2 }}> 
        <Typography variant="body1"><strong>Last Verified By</strong></Typography>
        <Typography variant="body1"><strong>Name : </strong> {verifiedBy.verifierName || "Not Available"}</Typography>
        <Typography variant="body1"><strong>Role :</strong> {verifiedBy.role || "Not Available"}</Typography>
      </Box>
      ) : (
        <p>No verification data available</p>
      )}
    </div>
      </div>
      {cropPlans && cropPlans.length > 0 ? (
        <>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
            Plan Item Details :
          </Typography>


          <div style={{ height: "400px", width: "100%" }}>
            <DataGrid
              rows={childdata.map((plan) => {
                const storedData = JSON.parse(localStorage.getItem("cropData")) || [];
                const isInactive = storedData.some((data) => data.cropPlanId === plan.cropPlanId);

                return {
                  id: plan.cropPlanId,
                  seedName: plan.seedName.trim(),
                  area: plan.area,
                  cropPlanDate: plan.cropPlanDate ? format(new Date(plan.cropPlanDate), "dd-MM-yyyy") : "NA",
                  leasearea: plan.leaseArea || 0,
                  className: plan.className,
                  varietyName: plan.varietyName.trim(),
                  cropType: plan.cropType,
                  status: plan.status,
                  isInactive, 

                };
              })}
              columns={[
                { field: "seedName", headerName: "Seed Name", flex: 1 },
                { field: "className", headerName: "Seed Class", flex: 1 },
                { field: "varietyName", headerName: "Seed Variety", flex: 1 },
                { field: "cropType", headerName: "Crop Type", flex: 1 },
                { field: "cropPlanDate", headerName: "Crop Plan Date", flex: 1 },
                {
                  field: "area",
                  headerName: "Planned Area(in ha.)",
                  flex: 1,
                  valueFormatter: (params) => `${params.value}`,
                },
                {
                  field: "leasearea",
                  headerName: "Lease Area(in ha.)",
                  flex: 1,
                  valueFormatter: (params) => `${params.value}`,
                },
                { field: "status", headerName: "Status", flex: 1 },
                {
                  field: "actions",
                  headerName: "Actions",
                  flex: 1,
                  renderCell: (params) => {
                    const isDisabled =
                      params.row.isInactive ||
                      ["CropProduction", "MarketLinkage"].includes(params.row.status);

                    return (
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Tooltip title="Edit">
                          <span>
                            <IconButton
                              onClick={() => handleEditClick(params.row)}
                              disabled={isDisabled}
                              sx={{ color: isDisabled ? "grey" : "blue" }}
                            >
                              <Edit />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <span>
                            <IconButton
                              onClick={() => handleDeleteClick(params.row)}
                              disabled={isDisabled}
                              sx={{ color: isDisabled ? "grey" : "red" }}
                            >
                              <Delete />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Cultivation">
                          <span>
                            <IconButton
                              onClick={() => handleCultivationClick(params.row)}
                              disabled={isDisabled}
                              sx={{ color: isDisabled ? "grey" : "green" }}
                            >
                              <Agriculture />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    );
                  },
                },
              ]}

              pageSize={5}
              disableSelectionOnClick
              pagination
              sx={{
                border: "1px solid #e0e0e0",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#fff", 
                  color: "black", 
                  fontWeight:'bold',

                },
                "& .MuiDataGrid-cell": {
                  fontSize: 14,
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#e3f2fd", 
                },
              }}
            />
          </div>

        </>
      ) : (
        <Typography>No crop plans available</Typography>
      )}

      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this crop plan?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Area Dialog */}
      <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
        <DialogTitle>Edit Crop Plan</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Area (hr)"
            value={updatedArea}
            onChange={handleAreaChange}
            helperText={`Total Available Land: ${totalAvailableArea} ha`}
            sx={{ marginTop: 2, marginBottom: 2 }}
          />
           <TextField
            fullWidth
            label="Lease Area (hr)"
            value={leaseArea}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*\.?\d*$/.test(value)) {
                setLeaseArea(value);
              }
            }}
            sx={{ marginTop: 2, marginBottom: 2 }} 
          />

          
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="seed-name-label">Seed Name</InputLabel>
            <Select
              labelId="seed-name-label"
              value={updatedSeedName}
              onChange={(e) => setUpdatedSeedName(e.target.value)}
              label="Seed Name"
            >
              {seeds.map((seed) => (
                <MenuItem key={seed.seedId} value={seed.seedId}>
                  {seed.seedName.trim()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="seed-class-label">Seed Class</InputLabel>
            <Select
              labelId="seed-class-label"
              value={updatedClassName}
              onChange={(e) => setUpdatedClassName(e.target.value)}
              label="Seed Class"
            >
              {seedClasses.map((seedClass) => (
                <MenuItem key={seedClass.seedClassId} value={seedClass.seedClassId}>
                  {seedClass.className.trim()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="seed-variety-label">Seed Variety</InputLabel>
            <Select
              labelId="seed-variety-label"
              value={updatedVarietyName}
              onChange={(e) => setUpdatedVarietyName(e.target.value)}
              label="Seed Variety"
            >
              {seedVarieties.map((seedVariety) => (
                <MenuItem key={seedVariety.seedVarietyId} value={seedVariety.seedVarietyId}>
                  {seedVariety.varietyName.trim()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="crop-type-label">Crop Type</InputLabel>
            <Select
              labelId="crop-type-label"
              value={updatedCropType}
              onChange={(e) => setUpdatedCropType(e.target.value)}
              label="Crop Type"
            >
              {cropTypes.map((cropType) => (
                <MenuItem key={cropType.cropTypeId} value={cropType.cropTypeId}>
                  {cropType.cropType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditConfirm} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Typography variant="body1">
        <strong>cropPlanMasterId:</strong> {farmerDetails.id || "Not Available"}
      </Typography> */}

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1976d2", // Attractive blue header
            color: "#fff",
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            padding: "16px",
          }}
        >
          Cultivation Details
        </DialogTitle>

        {/* Add spacing between DialogTitle and DialogContent */}
        <Box sx={{ height: "16px", backgroundColor: "#f5f5f5" }} />

        <DialogContent
          sx={{
            padding: "24px",
            backgroundColor: "#f5f5f5",
          }}
        >
          {/* <TextField
            fullWidth
            label="Class Name"
            name="className"
            value={formData.className}
            onChange={(e) => setFormData({ ...formData, className: e.target.value })}
            variant="outlined"
            sx={{ marginBottom: 2 }}
          /> */}
          <TextField
            fullWidth
            label="Seed Sowing Date"
            name="seedSowingDate"
            type="date"
            value={formData.seedSowingDate}
            onChange={handleChange}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="seed-class-label">Seed Class</InputLabel>
            <Select
              labelId="seed-class-label"
              name="seedClassId"
              value={formData.seedClassId}
              onChange={handleChange}
              label="Seed Class"
            >
              {seedClasses.map((seedClass) => (
                <MenuItem key={seedClass.seedClassId} value={seedClass.seedClassId}>
                  {seedClass.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="d-flex">
            <div className="col-4 d-flex align-items-center p-2">
              <Typography variant="h6">
                Total Planned Area =  <span className="text-bold">{plannedarea}</span> ha
              </Typography>
            </div>


            <div className="col-8">
              <TextField
                fullWidth
                label="Cultivated Area"
                name="cultivatedArea"
                value={formData.cultivatedArea}
                onChange={handleChange}
                variant="outlined"
                sx={{ marginBottom: 2 }}
                inputProps={{
                  inputMode: 'decimal', // Restricts to numeric input with decimals
                  pattern: "[0-9]*[.,]?[0-9]+" // Allows decimal numbers
                }}
              />
              
            </div>

          </div>

        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "space-between",
            padding: "16px",
            backgroundColor: "#e8eaf6",
          }}
        >
          <Button
            onClick={handleCloseDialog}
            variant="outlined"
            color="secondary"
            sx={{ fontWeight: "bold" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            sx={{
              fontWeight: "bold",
              backgroundColor: "#1976d2",
              ":hover": { backgroundColor: "#115293" },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default Plans;
